export default __webpack_public_path__ + "static/media/base_marker.f56018e2.svg";